export default (queryDocumentSnapshot = [], ignoreVersion = false, includeId = false) => {
  let i = 1;
  return Array.isArray(queryDocumentSnapshot) ? queryDocumentSnapshot.map((doc, index) => {
    const record =  doc.data();
    const lastRecord = index > 0 ? queryDocumentSnapshot[index - 1].data() : queryDocumentSnapshot[index].data();
    if (record.created_at && record.created_at !== lastRecord.created_at) {
      i += 1;
    }
    const result = ignoreVersion ? record : { ...record, version: i };
    return includeId ? { ...record, id: doc.id } : result;
  }) : [];
};
